export enum SizesEnum {
  default = '',
  xl = 'xl',
  l = 'l',
  m = 'm',
  s = 's',
  xs = 'xs',
  xxs = 'xxs'
}
